export default __webpack_public_path__ + "static/media/arrow-small-left.e5d8dceb.svg";